import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MarkUnreadChatAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mark_unread_chat_alt"}/>
}
